export function getCookieToken(): string | null {
    const match = document.cookie.match(/(^| )authToken=([^;]+)/);

    return match ? match[2] : null;
}
